"use client";

import { codeUsages } from "@/lib/openapi/code-usages";
import { createOpenAPIPage } from "fumadocs-openapi/ui";
import client from "@/components/api-page.client";
import { apiPageRenderers } from "@/components/api-page.renderers";

export const APIPage = createOpenAPIPage({
  ...client,
  codeUsages,
  ...apiPageRenderers,
});
